import {
  takeLatest, put, select, call,
} from 'redux-saga/effects';
import { api } from '@/utils/api';
import { config } from '@/config';
import { isBRServer } from '@/utils/Validators/validation';
import logger from '@/utils/logger';
import portalModalsActions from './portalModals.actions';
import { PortalModalsActionTypes } from './portalModals.types';

const { WHMCS_URL } = config;

export function* fetchPortalModalsSaga() {
  const { token, jwt: jwtToken } = yield select(state => state.auth);
  const brand = isBRServer ? 'br' : 'es';
  const { signal } = new AbortController();

  const request = {
    url: `${WHMCS_URL}/api/v3/modals`,
    headers: {
      Authorization: `Bearer ${token}`,
      'x-service-token': jwtToken ?? '',
      brand,
    },
    signal,
  };

  try {
    const response = yield call(api.whmcs.get, request);
    const raw = response?.data?.data?.modals;
    const modals = Array.isArray(raw) ? raw : [];
    yield put(portalModalsActions.fetch.success({ modals }));
  } catch (requestError) {
    const error = { ...requestError, userRequestData: request };
    logger.error('Error sagas portalModals - method fetchPortalModalsSaga', error);
    yield put(portalModalsActions.fetch.failure());
  }
}

function* sagas() {
  yield takeLatest(PortalModalsActionTypes.PORTAL_MODALS_FETCH_REQUEST, fetchPortalModalsSaga);
}

export default sagas;
